import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Paper,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Fade,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Snackbar,
  Alert,
  Chip,
  Tabs,
  Tab,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  Schedule as ScheduleIcon,
  Close as CloseIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { ThemeContext } from "../context/ThemeContext";

const AllQuiz = () => {
  const [deleteAllQuizDialogOpen, setDeleteAllQuizDialogOpen] = useState(false);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [assignmentData, setAssignmentData] = useState({
    assignment_type: "class",
    student_class: "",
    user_ids: [],
    access_type: "both",
  });
  const [classes, setClasses] = useState([]);
  const [users, setUsers] = useState([]);
  const { mode, customColors } = useContext(ThemeContext);
  const [quizzes, setQuizzes] = useState({
  own_created: [],
  class_assigned: [],
  user_assigned: [],
});
  const [scheduledQuizzes, setScheduledQuizzes] = useState([]);
  const [isLoadingQuizzes, setIsLoadingQuizzes] = useState(false);
  const [isLoadingScheduled, setIsLoadingScheduled] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [scheduleData, setScheduleData] = useState({ start_time: "", end_time: "" });
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [tabValue, setTabValue] = useState(0);
const [quizSubTab, setQuizSubTab] = useState(0); // 0: My Quiz, 1: Admin Assigned Quiz
  // New state for quiz status
  const [quizStatus, setQuizStatus] = useState([]);
  const [isLoadingQuizStatus, setIsLoadingQuizStatus] = useState(false);

  const token = sessionStorage.getItem("authToken");
  const userRole = sessionStorage.getItem("userRole");
const isStudent = userRole === "student" || "paid student";
  const apiUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

 const fetchQuizzes = async () => {
  setIsLoadingQuizzes(true);
  try {
    const response = await fetch(`${apiUrl}/my-quizzes/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error("Failed to fetch quizzes");
    const data = await response.json();
    setQuizzes({
      own_created: data.own_created_quizzes.data,
      class_assigned: data.class_assigned_quizzes.data,
      user_assigned: data.user_assigned_quizzes.data,
    });
  } catch (error) {
    setSnackbar({ open: true, message: error.message, severity: "error" });
  } finally {
    setIsLoadingQuizzes(false);
  }
};

  const fetchScheduledQuizzes = async () => {
    setIsLoadingScheduled(true);
    try {
      const response = await fetch(`${apiUrl}/quiz-schedules/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Failed to fetch scheduled quizzes");
      const data = await response.json();
      setScheduledQuizzes(data);
    } catch (error) {
      setSnackbar({ open: true, message: error.message, severity: "error" });
    } finally {
      setIsLoadingScheduled(false);
    }
  };

  const fetchQuizStatus = async () => {
    setIsLoadingQuizStatus(true);
    try {
      const response = await fetch(`${apiUrl}/admin-quiz-status/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Failed to fetch quiz status");
      const data = await response.json();
      setQuizStatus(data);
    } catch (error) {
      setSnackbar({ open: true, message: error.message, severity: "error" });
    } finally {
      setIsLoadingQuizStatus(false);
    }
  };

  const fetchClassesAndUsers = async () => {
    try {
      const [classesResponse, usersResponse] = await Promise.all([
        fetch(`${apiUrl}/admins/view-student-classes/`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        fetch(`${apiUrl}/custom-role/users/`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      if (!classesResponse.ok) throw new Error("Failed to fetch classes");
      if (!usersResponse.ok) throw new Error("Failed to fetch users");

      const classesData = await classesResponse.json();
      const usersData = await usersResponse.json();

      setClasses(classesData);

      const allowedRoles = ["student", "paid student"];
      const filteredUsers = allowedRoles
        .flatMap((role) => usersData.custom_roles[role] ?? [])
        .map((user) => ({
          ...user,
          name: `${user.first_name} ${user.last_name}`.trim(),
        }));

      setUsers(filteredUsers);
    } catch (error) {
      setSnackbar({ open: true, message: error.message, severity: "error" });
    }
  };

  useEffect(() => {
    if (tabValue === 0) {
      fetchQuizzes();
    } else if (tabValue === 1) {
      fetchScheduledQuizzes();
    } else if (tabValue === 2) {
      fetchQuizStatus();
    }
  }, [tabValue]);


  const handleDeleteQuiz = async () => {
  try {
    const response = await fetch(`${apiUrl}/quiz/${selectedQuiz.id}/`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error("Failed to delete quiz");
    setSnackbar({ open: true, message: "Quiz deleted successfully!", severity: "success" });
    setDeleteAllQuizDialogOpen(false);
    fetchQuizzes();
  } catch (error) {
    setSnackbar({ open: true, message: error.message, severity: "error" });
  }
};

  const handleScheduleQuiz = async () => {
    try {
      const response = await fetch(`${apiUrl}/quiz-schedules/`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ quiz: selectedQuiz.id, ...scheduleData }),
      });
      if (!response.ok) throw new Error("Failed to schedule quiz");
      const data = await response.json();
      setSnackbar({ open: true, message: `Quiz scheduled successfully! Schedule ID: ${data.id}`, severity: "success" });
      setScheduleModalOpen(false);
      fetchScheduledQuizzes();
    } catch (error) {
      setSnackbar({ open: true, message: error.message, severity: "error" });
    }
  };

  const handleAssignQuiz = async () => {
    if (!selectedSchedule) {
      setSnackbar({ open: true, message: "No schedule selected.", severity: "error" });
      return;
    }

    if (assignmentData.assignment_type === "class" && !assignmentData.student_class) {
      setSnackbar({ open: true, message: "Please select a class.", severity: "error" });
      return;
    }

    if (assignmentData.assignment_type === "user" && assignmentData.user_ids.length === 0) {
      setSnackbar({ open: true, message: "Please select at least one user.", severity: "error" });
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/quiz-assignments/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          schedule: selectedSchedule.id,
          ...assignmentData,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Failed to assign quiz.");
      }

      setSnackbar({ open: true, message: "Quiz assigned successfully!", severity: "success" });
      setAssignModalOpen(false);
    } catch (error) {
      setSnackbar({ open: true, message: error.message, severity: "error" });
    }
  };

  const handleStartQuiz = async (quiz) => {
    try {
      const response = await fetch(`${apiUrl}/quiz/${quiz.id}/questions/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Failed to fetch quiz questions");
      const questions = await response.json();
      navigate(`/practice/${quiz.id}`, {
        state: {
          quizId: quiz.id,
          questionTypes: quiz.question_types,
          negativeMarking: quiz.neg_marking,
          timerEnabled: !!quiz.time_limit_minutes,
        }
      });
    } catch (error) {
      setSnackbar({ open: true, message: error.message, severity: "error" });
    }
  };

  const handleEditSchedule = (schedule) => {
  const start = new Date(schedule.start_time);
  const end = new Date(schedule.end_time);

  // Format for datetime-local input (YYYY-MM-DDTHH:mm)
  const formatForInput = (date) => {
    const pad = (num) => num.toString().padStart(2, '0');
    return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}T${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
  };

  setSelectedSchedule(schedule);
  setScheduleData({
    start_time: formatForInput(start),
    end_time: formatForInput(end),
  });
  setEditModalOpen(true);
};

  const handleUpdateSchedule = async () => {
  try {
    const response = await fetch(`${apiUrl}/quiz-schedules/${selectedSchedule.id}/`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      body: JSON.stringify({
        quiz: selectedSchedule.quiz, // or selectedSchedule.quiz_id
        ...scheduleData,
      }),
    });
    if (!response.ok) throw new Error("Failed to update schedule");
    setSnackbar({ open: true, message: "Schedule updated successfully!", severity: "success" });
    setEditModalOpen(false);
    fetchScheduledQuizzes();
  } catch (error) {
    setSnackbar({ open: true, message: error.message, severity: "error" });
  }
}; 

  const handleDeleteSchedule = async () => {
    try {
      const response = await fetch(`${apiUrl}/quiz-schedules/${selectedSchedule.id}/`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Failed to delete schedule");
      setSnackbar({ open: true, message: "Schedule deleted successfully!", severity: "success" });
      setDeleteDialogOpen(false);
      fetchScheduledQuizzes();
    } catch (error) {
      setSnackbar({ open: true, message: error.message, severity: "error" });
    }
  };

  return (
    <Box sx={{ padding: 4, minHeight: "100vh", backgroundColor: mode === "dark" ? "#121212" : "#F5F5F5" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: mode === "dark" ? "#fff" : "#2c3e50" }}>
          My Quizzes
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate("/create-quiz")}
          sx={{
            background: "linear-gradient(135deg, #1e3a8a 0%, #1e8bafff 100%)",
            color: "#fff",
            "&:hover": { background: "linear-gradient(135deg, #1e8bafff 0%, #1e3a8a 100%)" },
          }}
        >
          Create Quiz
        </Button>
      </Box>

      <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)} sx={{ mb: 3 }}>
        <Tab label="All Quizzes" />
        {!isStudent && <Tab label="Scheduled Quizzes" />}
  {!isStudent && <Tab label="Quiz Status" />}
      </Tabs>

     {tabValue === 0 ? (
  <>
    {isStudent && (
      <Tabs
        value={quizSubTab}
        onChange={(e, newValue) => setQuizSubTab(newValue)}
        sx={{ mb: 3 }}
      >
        <Tab label="My Quiz" />
        <Tab label="Admin Assigned Quiz" />
      </Tabs>
    )}

    {isLoadingQuizzes ? (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          my: 8,
          gap: 2,
        }}
      >
        <CircularProgress
          size={48}
          thickness={3}
          sx={{ color: "#1e8baf" }}
        />
        <Typography
          variant="body2"
          sx={{ color: mode === "dark" ? "#888" : "#999", letterSpacing: "0.05em" }}
        >
          Loading quizzes...
        </Typography>
      </Box>
    ) : (
      <>
        {isStudent && quizSubTab === 0 && quizzes.own_created.length === 0 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              my: 10,
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: "20px",
                background: mode === "dark"
                  ? "linear-gradient(135deg, #1e2a35 0%, #1a3a4a 100%)"
                  : "linear-gradient(135deg, #e8f4f8 0%, #d0eaf4 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "32px",
                mb: 1,
              }}
            >
              📋
            </Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: mode === "dark" ? "#ccc" : "#444",
                letterSpacing: "-0.01em",
              }}
            >
              No quizzes yet
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: mode === "dark" ? "#666" : "#999", textAlign: "center", maxWidth: 300 }}
            >
              Create a new quiz to get started on your learning journey.
            </Typography>
          </Box>
        )}

        {isStudent && quizSubTab === 1 && quizzes.class_assigned.length === 0 && quizzes.user_assigned.length === 0 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              my: 10,
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: "20px",
                background: mode === "dark"
                  ? "linear-gradient(135deg, #1e2a35 0%, #1a3a4a 100%)"
                  : "linear-gradient(135deg, #e8f4f8 0%, #d0eaf4 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "32px",
                mb: 1,
              }}
            >
              📋
            </Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: mode === "dark" ? "#ccc" : "#444",
                letterSpacing: "-0.01em",
              }}
            >
              No admin-assigned quizzes
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: mode === "dark" ? "#666" : "#999", textAlign: "center", maxWidth: 300 }}
            >
              You have no quizzes assigned by admin yet.
            </Typography>
          </Box>
        )}

        {!isStudent && quizzes.length === 0 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              my: 10,
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: "20px",
                background: mode === "dark"
                  ? "linear-gradient(135deg, #1e2a35 0%, #1a3a4a 100%)"
                  : "linear-gradient(135deg, #e8f4f8 0%, #d0eaf4 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "32px",
                mb: 1,
              }}
            >
              📋
            </Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: mode === "dark" ? "#ccc" : "#444",
                letterSpacing: "-0.01em",
              }}
            >
              No quizzes yet
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: mode === "dark" ? "#666" : "#999", textAlign: "center", maxWidth: 300 }}
            >
              Create a new quiz to get started on your learning journey.
            </Typography>
          </Box>
        )}

    {(!isStudent || (isStudent && (quizSubTab === 0 ? quizzes.own_created.length > 0 : (quizzes.class_assigned.length > 0 || quizzes.user_assigned.length > 0)))) && (
  <Grid container spacing={3}>
    {(isStudent
      ? quizSubTab === 0
        ? quizzes.own_created
        : [...quizzes.class_assigned, ...quizzes.user_assigned]
      : quizzes.own_created // For non-students, use quizzes.own_created (or the original array if you prefer)
    ).map((quiz, index) => (
              <Grid item xs={12} md={6} lg={4} key={quiz.id}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 0,
                    borderRadius: "20px",
                    background: mode === "dark"
                      ? "linear-gradient(145deg, #1a2230 0%, #1e2a38 100%)"
                      : "linear-gradient(145deg, #ffffff 0%, #f8fbfd 100%)",
                    border: mode === "dark"
                      ? "1px solid rgba(255,255,255,0.06)"
                      : "1px solid rgba(30,139,175,0.12)",
                    boxShadow: mode === "dark"
                      ? "0 8px 32px rgba(0,0,0,0.4), 0 1px 0 rgba(255,255,255,0.04) inset"
                      : "0 8px 32px rgba(30,139,175,0.08), 0 1px 0 rgba(255,255,255,0.9) inset",
                    transition: "transform 0.25s ease, box-shadow 0.25s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: mode === "dark"
                        ? "0 20px 48px rgba(0,0,0,0.5), 0 1px 0 rgba(255,255,255,0.06) inset"
                        : "0 20px 48px rgba(30,139,175,0.14), 0 1px 0 rgba(255,255,255,0.9) inset",
                    },
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <Box
                    sx={{
                      height: "3px",
                      background: `linear-gradient(90deg, #1e8baf ${index % 3 === 0 ? "0%" : "20%"}, #4ec9e8 100%)`,
                      opacity: 0.85,
                    }}
                  />

                  <Box sx={{ p: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", mb: 2 }}>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 700,
                          color: mode === "dark" ? "#f0f4f8" : "#1a2a3a",
                          letterSpacing: "-0.02em",
                          lineHeight: 1.3,
                          flex: 1,
                          pr: 1,
                        }}
                      >
                        {quiz.title}
                      </Typography>
                     {(isStudent && quizSubTab === 0) || !isStudent ? (
  <IconButton
    onClick={() => {
      setSelectedQuiz(quiz);
      setDeleteAllQuizDialogOpen(true);
    }}
    sx={{
      minWidth: 36,
      height: 36,
      borderRadius: "10px",
      background: mode === "dark"
        ? "rgba(244,67,54,0.15)"
        : "rgba(244,67,54,0.08)",
      color: "#f44336",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      "&:hover": {
        background: mode === "dark"
          ? "rgba(244,67,54,0.25)"
          : "rgba(244,67,54,0.12)",
      },
    }}
  >
    <DeleteIcon sx={{ fontSize: 16 }} />
  </IconButton>
) : null}
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        gap: 1.5,
                        mb: 2.5,
                        flexWrap: "wrap",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.6,
                          px: 1.2,
                          py: 0.4,
                          borderRadius: "8px",
                          background: mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(30,139,175,0.07)",
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{ color: "#1e8baf", fontWeight: 700, fontSize: "11px", letterSpacing: "0.03em" }}
                        >
                          {quiz.total_questions}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: mode === "dark" ? "#888" : "#999", fontSize: "11px" }}
                        >
                          Questions
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.6,
                          px: 1.2,
                          py: 0.4,
                          borderRadius: "8px",
                          background: mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(76,175,80,0.07)",
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{ color: "#4caf50", fontWeight: 700, fontSize: "11px" }}
                        >
                          {quiz.passing_percentage}%
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: mode === "dark" ? "#888" : "#999", fontSize: "11px" }}
                        >
                          to Pass
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="caption"
                        sx={{
                          color: mode === "dark" ? "#666" : "#aaa",
                          fontSize: "10px",
                          fontWeight: 600,
                          letterSpacing: "0.08em",
                          textTransform: "uppercase",
                          display: "block",
                          mb: 0.8,
                        }}
                      >
                        Question Types
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.6 }}>
                        {quiz.question_types.map((type) => (
                          <Chip
                            key={type}
                            label={type}
                            size="small"
                            sx={{
                              height: "22px",
                              fontSize: "11px",
                              fontWeight: 500,
                              borderRadius: "6px",
                              background: mode === "dark" ? "rgba(30,139,175,0.12)" : "rgba(30,139,175,0.07)",
                              color: mode === "dark" ? "#5bbcd8" : "#1e8baf",
                              border: "none",
                              "& .MuiChip-label": { px: 1 },
                            }}
                          />
                        ))}
                      </Box>
                    </Box>

                    {quiz.folders && quiz.folders.length > 0 && (
                      <Box sx={{ mb: 2.5 }}>
                        <Typography
                          variant="caption"
                          sx={{
                            color: mode === "dark" ? "#666" : "#aaa",
                            fontSize: "10px",
                            fontWeight: 600,
                            letterSpacing: "0.08em",
                            textTransform: "uppercase",
                            display: "block",
                            mb: 0.8,
                          }}
                        >
                          Folders
                        </Typography>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.6 }}>
                          {quiz.folders.map((folderId) => (
                            <Chip
                              key={folderId}
                              label={`📁 Folder ${folderId}`}
                              size="small"
                              sx={{
                                height: "22px",
                                fontSize: "11px",
                                fontWeight: 500,
                                borderRadius: "6px",
                                background: mode === "dark" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
                                color: mode === "dark" ? "#aaa" : "#666",
                                border: "none",
                                "& .MuiChip-label": { px: 1 },
                              }}
                            />
                          ))}
                        </Box>
                      </Box>
                    )}

                    <Box
                      sx={{
                        height: "1px",
                        background: mode === "dark"
                          ? "rgba(255,255,255,0.06)"
                          : "rgba(0,0,0,0.06)",
                        mb: 2.5,
                      }}
                    />

                    <Box sx={{ display: "flex", gap: 1.5 }}>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleStartQuiz(quiz)}
                        disableElevation
                        sx={{
                          flex: 1,
                          borderRadius: "10px",
                          py: 1,
                          fontSize: "13px",
                          fontWeight: 600,
                          letterSpacing: "0.02em",
                          background: "linear-gradient(135deg, #1e8baf 0%, #1679a0 100%)",
                          color: "#fff",
                          textTransform: "none",
                          boxShadow: "0 4px 12px rgba(30,139,175,0.3)",
                          "&:hover": {
                            background: "linear-gradient(135deg, #2299c0 0%, #1e8baf 100%)",
                            boxShadow: "0 6px 18px rgba(30,139,175,0.4)",
                          },
                        }}
                      >
                        ▶ Start
                      </Button>
                      {!isStudent && (
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            setSelectedQuiz(quiz);
                            setScheduleModalOpen(true);
                          }}
                          sx={{
                            flex: 1,
                            borderRadius: "10px",
                            py: 1,
                            fontSize: "13px",
                            fontWeight: 600,
                            letterSpacing: "0.02em",
                            textTransform: "none",
                            borderColor: mode === "dark" ? "rgba(76,175,80,0.4)" : "rgba(76,175,80,0.5)",
                            color: "#4caf50",
                            "&:hover": {
                              borderColor: "#4caf50",
                              background: "rgba(76,175,80,0.06)",
                            },
                          }}
                        >
                          🗓 Schedule
                        </Button>
                      )}
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        )}
      </>
    )}
  </>
) : tabValue === 1 ? (
        isLoadingScheduled ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              my: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} thickness={3} sx={{ color: "#1e8baf" }} />
            <Typography
              variant="body2"
              sx={{ color: mode === "dark" ? "#888" : "#999", letterSpacing: "0.05em" }}
            >
              Loading scheduled quizzes...
            </Typography>
          </Box>
        ) : scheduledQuizzes.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              my: 10,
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: "20px",
                background: mode === "dark"
                  ? "linear-gradient(135deg, #1e2a35 0%, #1a3a4a 100%)"
                  : "linear-gradient(135deg, #e8f4f8 0%, #d0eaf4 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "32px",
                mb: 1,
              }}
            >
              🗓
            </Box>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, color: mode === "dark" ? "#ccc" : "#444", letterSpacing: "-0.01em" }}
            >
              No scheduled quizzes
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: mode === "dark" ? "#666" : "#999", textAlign: "center", maxWidth: 300 }}
            >
              Schedule a quiz to assign it to your students at a specific time.
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={3}>
            {scheduledQuizzes.map((schedule) => {
              const start = new Date(schedule.start_time);
              const end = new Date(schedule.end_time);
              const now = new Date();
              const isLive = now >= start && now <= end;
              const isUpcoming = now < start;

              const statusColor = isLive ? "#4caf50" : isUpcoming ? "#1e8baf" : "#888";
              const statusLabel = isLive ? "Live" : isUpcoming ? "Upcoming" : "Ended";
              const statusIcon = isLive ? "🟢" : isUpcoming ? "🔵" : "⚫";

              return (
                <Grid item xs={12} md={6} lg={4} key={schedule.id}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 0,
                      borderRadius: "20px",
                      background: mode === "dark"
                        ? "linear-gradient(145deg, #1a2230 0%, #1e2a38 100%)"
                        : "linear-gradient(145deg, #ffffff 0%, #f8fbfd 100%)",
                      border: mode === "dark"
                        ? "1px solid rgba(255,255,255,0.06)"
                        : "1px solid rgba(30,139,175,0.12)",
                      boxShadow: mode === "dark"
                        ? "0 8px 32px rgba(0,0,0,0.4), 0 1px 0 rgba(255,255,255,0.04) inset"
                        : "0 8px 32px rgba(30,139,175,0.08), 0 1px 0 rgba(255,255,255,0.9) inset",
                      transition: "transform 0.25s ease, box-shadow 0.25s ease",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        boxShadow: mode === "dark"
                          ? "0 20px 48px rgba(0,0,0,0.5), 0 1px 0 rgba(255,255,255,0.06) inset"
                          : "0 20px 48px rgba(30,139,175,0.14), 0 1px 0 rgba(255,255,255,0.9) inset",
                      },
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    <Box
                      sx={{
                        height: "3px",
                        background: "linear-gradient(90deg, #1e8baf 0%, #4ec9e8 100%)",
                        opacity: 0.85,
                      }}
                    />

                    <Box sx={{ p: 3 }}>
                      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", mb: 2 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: mode === "dark" ? "#f0f4f8" : "#1a2a3a",
                            letterSpacing: "-0.02em",
                            lineHeight: 1.3,
                            flex: 1,
                            pr: 1,
                          }}
                        >
                         {schedule.quiz_title || "Untitled Quiz"}
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            px: 1.2,
                            py: 0.4,
                            borderRadius: "20px",
                            background: `${statusColor}18`,
                            border: `1px solid ${statusColor}30`,
                            flexShrink: 0,
                          }}
                        >
                          <Box sx={{ fontSize: "9px", lineHeight: 1 }}>{statusIcon}</Box>
                          <Typography
                            variant="caption"
                            sx={{ color: statusColor, fontWeight: 700, fontSize: "11px", letterSpacing: "0.04em" }}
                          >
                            {statusLabel}
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          borderRadius: "12px",
                          background: mode === "dark" ? "rgba(255,255,255,0.04)" : "rgba(30,139,175,0.04)",
                          border: mode === "dark" ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(30,139,175,0.08)",
                          p: 1.5,
                          mb: 2.5,
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: mode === "dark" ? "#666" : "#aaa",
                              fontSize: "10px",
                              fontWeight: 700,
                              letterSpacing: "0.08em",
                              textTransform: "uppercase",
                              minWidth: 36,
                            }}
                          >
                            Start
                          </Typography>
                          <Typography variant="body2" sx={{ color: mode === "dark" ? "#c8dff0" : "#1a3a4a", fontWeight: 500, fontSize: "13px" }}>
  {start.toLocaleString('en-US', {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "UTC",
  })}
</Typography>
                        </Box>

                        <Box
                          sx={{
                            height: "1px",
                            background: mode === "dark" ? "rgba(255,255,255,0.06)" : "rgba(30,139,175,0.08)",
                          }}
                        />

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: mode === "dark" ? "#666" : "#aaa",
                              fontSize: "10px",
                              fontWeight: 700,
                              letterSpacing: "0.08em",
                              textTransform: "uppercase",
                              minWidth: 36,
                            }}
                          >
                            End
                          </Typography>
                          <Typography
    variant="body2"
    sx={{ color: mode === "dark" ? "#c8dff0" : "#1a3a4a", fontWeight: 500, fontSize: "13px" }}
  >
    {end.toLocaleString('en-US', {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "UTC",
    })}
  </Typography>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          height: "1px",
                          background: mode === "dark" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)",
                          mb: 2.5,
                        }}
                      />

                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => handleEditSchedule(schedule)}
                          sx={{
                            flex: 1,
                            borderRadius: "10px",
                            py: 0.9,
                            fontSize: "12px",
                            fontWeight: 600,
                            textTransform: "none",
                            letterSpacing: "0.02em",
                            borderColor: mode === "dark" ? "rgba(255,152,0,0.4)" : "rgba(255,152,0,0.5)",
                            color: "#ff9800",
                            gap: 0.5,
                            "&:hover": {
                              borderColor: "#ff9800",
                              background: "rgba(255,152,0,0.06)",
                            },
                          }}
                        >
                          <EditIcon sx={{ fontSize: 14 }} />
                          Edit
                        </Button>

                        <Button
                          variant="contained"
                          size="small"
                          disableElevation
                          onClick={() => {
                            setSelectedSchedule(schedule);
                            setAssignModalOpen(true);
                            fetchClassesAndUsers();
                          }}
                          sx={{
                            flex: 1,
                            borderRadius: "10px",
                            py: 0.9,
                            fontSize: "12px",
                            fontWeight: 600,
                            textTransform: "none",
                            letterSpacing: "0.02em",
                            background: "linear-gradient(135deg, #1e8baf 0%, #1679a0 100%)",
                            color: "#fff",
                            boxShadow: "0 4px 12px rgba(30,139,175,0.3)",
                            "&:hover": {
                              background: "linear-gradient(135deg, #2299c0 0%, #1e8baf 100%)",
                              boxShadow: "0 6px 18px rgba(30,139,175,0.4)",
                            },
                          }}
                        >
                          Assign
                        </Button>

                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            setSelectedSchedule(schedule);
                            setDeleteDialogOpen(true);
                          }}
                          sx={{
                            minWidth: 0,
                            width: 38,
                            borderRadius: "10px",
                            py: 0.9,
                            px: 0,
                            borderColor: mode === "dark" ? "rgba(244,67,54,0.35)" : "rgba(244,67,54,0.4)",
                            color: "#f44336",
                            "&:hover": {
                              borderColor: "#f44336",
                              background: "rgba(244,67,54,0.06)",
                            },
                          }}
                        >
                          <DeleteIcon sx={{ fontSize: 16 }} />
                        </Button>
                      </Box>
                    </Box>
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        )
      ) : (
        isLoadingQuizStatus ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              my: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} thickness={3} sx={{ color: "#1e8baf" }} />
            <Typography
              variant="body2"
              sx={{ color: mode === "dark" ? "#888" : "#999", letterSpacing: "0.05em" }}
            >
              Loading quiz status...
            </Typography>
          </Box>
        ) : quizStatus.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              my: 10,
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: "20px",
                background: mode === "dark"
                  ? "linear-gradient(135deg, #1e2a35 0%, #1a3a4a 100%)"
                  : "linear-gradient(135deg, #e8f4f8 0%, #d0eaf4 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "32px",
                mb: 1,
              }}
            >
              📊
            </Box>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, color: mode === "dark" ? "#ccc" : "#444", letterSpacing: "-0.01em" }}
            >
              No quiz status available
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: mode === "dark" ? "#666" : "#999", textAlign: "center", maxWidth: 300 }}
            >
              Quiz status will appear here once quizzes are assigned to students.
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={3}>
            {quizStatus.map((status, index) => (
              <Grid item xs={12} key={status.quiz.quiz_id}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    borderRadius: "20px",
                    background: mode === "dark"
                      ? "linear-gradient(145deg, #1a2230 0%, #1e2a38 100%)"
                      : "linear-gradient(145deg, #ffffff 0%, #f8fbfd 100%)",
                    border: mode === "dark"
                      ? "1px solid rgba(255,255,255,0.06)"
                      : "1px solid rgba(30,139,175,0.12)",
                    boxShadow: mode === "dark"
                      ? "0 8px 32px rgba(0,0,0,0.4), 0 1px 0 rgba(255,255,255,0.04) inset"
                      : "0 8px 32px rgba(30,139,175,0.08), 0 1px 0 rgba(255,255,255,0.9) inset",
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
                    {status.quiz.title}
                  </Typography>

                  <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                    <Box>
                      <Typography variant="caption" sx={{ color: mode === "dark" ? "#888" : "#999" }}>
                        Total Questions
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {status.quiz.total_questions}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="caption" sx={{ color: mode === "dark" ? "#888" : "#999" }}>
                        Passing Percentage
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {status.quiz.passing_percentage}%
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="caption" sx={{ color: mode === "dark" ? "#888" : "#999" }}>
                        Total Students
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        {status.total_students}
                      </Typography>
                    </Box>
                  </Box>

                  {status.students.length > 0 && (
                    <TableContainer component={Paper} sx={{ mt: 2, borderRadius: "12px" }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 600 }}>Student Email</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Attempt Count</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {status.students.map((student) => (
                            <TableRow key={student.user_id}>
                              <TableCell>{student.email}</TableCell>
                              <TableCell>{student.attempt_count}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Paper>
              </Grid>
            ))}
          </Grid>
        )
      )}

      <Modal
        open={scheduleModalOpen}
        onClose={() => {
          setScheduleModalOpen(false);
          setScheduleData({
            start_time: "",
            end_time: "",
          });
        }}
      >
        <Fade in={scheduleModalOpen}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 500,
              bgcolor: "background.paper",
              borderRadius: "16px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
              p: 3,
              outline: "none",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 3,
                fontWeight: "800",
                fontSize: "1.8rem",
                background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                paddingBottom: "10px",
                borderBottom: "2px solid #e5e7eb",
                textAlign: "center",
              }}
            >
              Schedule Quiz
            </Typography>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="Start Time"
                type="datetime-local"
                value={scheduleData.start_time}
                onChange={(e) => setScheduleData({ ...scheduleData, start_time: e.target.value })}
                InputLabelProps={{ shrink: true }}
                inputProps={{ step: 300 }}
                error={!scheduleData.start_time}
                helperText={!scheduleData.start_time ? "Start time is required" : ""}
                sx={{
                  borderRadius: "12px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(99, 102, 241, 0.15)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(99, 102, 241, 0.45)",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#6366f1",
                    borderWidth: "1.5px",
                  },
                }}
              />
            </FormControl>

            <FormControl fullWidth sx={{ mb: 3 }}>
              <TextField
                label="End Time"
                type="datetime-local"
                value={scheduleData.end_time}
                onChange={(e) => setScheduleData({ ...scheduleData, end_time: e.target.value })}
                InputLabelProps={{ shrink: true }}
                inputProps={{ step: 300 }}
                error={
                  !scheduleData.end_time ||
                  (scheduleData.start_time &&
                   scheduleData.end_time &&
                   new Date(scheduleData.end_time) <= new Date(scheduleData.start_time))
                }
                helperText={
                  !scheduleData.end_time
                    ? "End time is required"
                    : (scheduleData.start_time &&
                       scheduleData.end_time &&
                       new Date(scheduleData.end_time) <= new Date(scheduleData.start_time))
                      ? "End time must be after start time"
                      : ""
                }
                sx={{
                  borderRadius: "12px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(99, 102, 241, 0.15)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(99, 102, 241, 0.45)",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#6366f1",
                    borderWidth: "1.5px",
                  },
                }}
              />
            </FormControl>

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 2,
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setScheduleModalOpen(false);
                  setScheduleData({
                    start_time: "",
                    end_time: "",
                  });
                }}
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  padding: "8px 20px",
                  borderColor: "rgba(99, 102, 241, 0.3)",
                  "&:hover": {
                    borderColor: "#6366f1",
                    backgroundColor: "rgba(99, 102, 241, 0.04)",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleScheduleQuiz}
                disabled={
                  !scheduleData.start_time ||
                  !scheduleData.end_time ||
                  (scheduleData.start_time &&
                   scheduleData.end_time &&
                   new Date(scheduleData.end_time) <= new Date(scheduleData.start_time))
                }
                sx={{
                  background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                  color: "white",
                  borderRadius: "10px",
                  textTransform: "none",
                  padding: "8px 20px",
                  "&:hover": {
                    background: "linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%)",
                  },
                  "&.Mui-disabled": {
                    background: "#a5d6a7",
                  },
                }}
              >
                Schedule
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>

      <Modal
        open={editModalOpen}
        onClose={() => {
          setEditModalOpen(false);
          setScheduleData({
            start_time: "",
            end_time: "",
          });
        }}
      >
        <Fade in={editModalOpen}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 500,
              bgcolor: "background.paper",
              borderRadius: "16px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
              p: 3,
              outline: "none",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 3,
                fontWeight: "800",
                fontSize: "1.8rem",
                background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                paddingBottom: "10px",
                borderBottom: "2px solid #e5e7eb",
                textAlign: "center",
              }}
            >
              Edit Schedule
            </Typography>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="Start Time"
                type="datetime-local"
                value={scheduleData.start_time}
                onChange={(e) => setScheduleData({ ...scheduleData, start_time: e.target.value })}
                InputLabelProps={{ shrink: true }}
                inputProps={{ step: 300 }}
                error={!scheduleData.start_time}
                helperText={!scheduleData.start_time ? "Start time is required" : ""}
                sx={{
                  borderRadius: "12px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(99, 102, 241, 0.15)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(99, 102, 241, 0.45)",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#6366f1",
                    borderWidth: "1.5px",
                  },
                }}
              />
            </FormControl>

            <FormControl fullWidth sx={{ mb: 3 }}>
              <TextField
                label="End Time"
                type="datetime-local"
                value={scheduleData.end_time}
                onChange={(e) => setScheduleData({ ...scheduleData, end_time: e.target.value })}
                InputLabelProps={{ shrink: true }}
                inputProps={{ step: 300 }}
                error={
                  !scheduleData.end_time ||
                  (scheduleData.start_time &&
                   scheduleData.end_time &&
                   new Date(scheduleData.end_time) <= new Date(scheduleData.start_time))
                }
                helperText={
                  !scheduleData.end_time
                    ? "End time is required"
                    : (scheduleData.start_time &&
                       scheduleData.end_time &&
                       new Date(scheduleData.end_time) <= new Date(scheduleData.start_time))
                      ? "End time must be after start time"
                      : ""
                }
                sx={{
                  borderRadius: "12px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(99, 102, 241, 0.15)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(99, 102, 241, 0.45)",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#6366f1",
                    borderWidth: "1.5px",
                  },
                }}
              />
            </FormControl>

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 2,
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setEditModalOpen(false);
                  setScheduleData({
                    start_time: "",
                    end_time: "",
                  });
                }}
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  padding: "8px 20px",
                  borderColor: "rgba(99, 102, 241, 0.3)",
                  "&:hover": {
                    borderColor: "#6366f1",
                    backgroundColor: "rgba(99, 102, 241, 0.04)",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleUpdateSchedule}
                disabled={
                  !scheduleData.start_time ||
                  !scheduleData.end_time ||
                  (scheduleData.start_time &&
                   scheduleData.end_time &&
                   new Date(scheduleData.end_time) <= new Date(scheduleData.start_time))
                }
                sx={{
                  background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                  color: "white",
                  borderRadius: "10px",
                  textTransform: "none",
                  padding: "8px 20px",
                  "&:hover": {
                    background: "linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%)",
                  },
                  "&.Mui-disabled": {
                    background: "#a5d6a7",
                  },
                }}
              >
                Update
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>

      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
            p: 2,
            width: "400px",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "800",
            fontSize: "1.5rem",
            background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            textAlign: "center",
            paddingBottom: "10px",
            borderBottom: "1px solid #f3f4f6",
          }}
        >
          Delete Schedule
        </DialogTitle>

        <DialogContent sx={{ textAlign: "center", py: 2 }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Are you sure you want to delete this schedule?
          </Typography>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 2 }}>
          <Button
            onClick={() => setDeleteDialogOpen(false)}
            variant="outlined"
            sx={{
              borderRadius: "10px",
              textTransform: "none",
              padding: "8px 20px",
              borderColor: "rgba(99, 102, 241, 0.3)",
              color: "#6366f1",
              "&:hover": {
                borderColor: "#6366f1",
                backgroundColor: "rgba(99, 102, 241, 0.04)",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteSchedule}
            variant="contained"
            sx={{
              background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
              color: "white",
              borderRadius: "10px",
              textTransform: "none",
              padding: "8px 20px",
              "&:hover": {
                background: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
              },
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Modal
        open={assignModalOpen}
        onClose={() => {
          setAssignModalOpen(false);
          setAssignmentData({
            assignment_type: "class",
            student_class: "",
            user_ids: [],
            access_type: "both",
          });
        }}
      >
        <Fade in={assignModalOpen}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 500,
              bgcolor: "background.paper",
              borderRadius: "16px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
              p: 3,
              outline: "none",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 3,
                fontWeight: "800",
                fontSize: "1.8rem",
                background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                paddingBottom: "10px",
                borderBottom: "2px solid #e5e7eb",
                textAlign: "center",
              }}
            >
              Assign Quiz
            </Typography>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel
                sx={{
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  "&.Mui-focused": { color: "#6366f1" },
                }}
              >
                Assignment Type
              </InputLabel>
              <Select
                value={assignmentData.assignment_type}
                onChange={(e) =>
                  setAssignmentData({ ...assignmentData, assignment_type: e.target.value })
                }
                label="Assignment Type"
                sx={{
                  borderRadius: "12px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(99, 102, 241, 0.15)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(99, 102, 241, 0.45)",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#6366f1",
                    borderWidth: "1.5px",
                  },
                }}
              >
                <MenuItem value="class">Class</MenuItem>
                <MenuItem value="user">User</MenuItem>
              </Select>
            </FormControl>

            {assignmentData.assignment_type === "class" && (
              <>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: 500,
                      "&.Mui-focused": { color: "#6366f1" },
                    }}
                  >
                    Select Class
                  </InputLabel>
                  <Select
                    value={assignmentData.student_class}
                    onChange={(e) =>
                      setAssignmentData({ ...assignmentData, student_class: e.target.value })
                    }
                    label="Select Class"
                    sx={{
                      borderRadius: "12px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(99, 102, 241, 0.15)",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(99, 102, 241, 0.45)",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6366f1",
                        borderWidth: "1.5px",
                      },
                    }}
                  >
                    {classes.map((cls) => (
                      <MenuItem key={cls.id} value={String(cls.id)}>
                        {cls.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: 500,
                      "&.Mui-focused": { color: "#6366f1" },
                    }}
                  >
                    Access Type
                  </InputLabel>
                  <Select
                    value={assignmentData.access_type}
                    onChange={(e) =>
                      setAssignmentData({ ...assignmentData, access_type: e.target.value })
                    }
                    label="Access Type"
                    sx={{
                      borderRadius: "12px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(99, 102, 241, 0.15)",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(99, 102, 241, 0.45)",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6366f1",
                        borderWidth: "1.5px",
                      },
                    }}
                  >
                    <MenuItem value="free">Free</MenuItem>
                    <MenuItem value="paid">Paid</MenuItem>
                    <MenuItem value="both">Both</MenuItem>
                  </Select>
                </FormControl>
              </>
            )}

            {assignmentData.assignment_type === "user" && (
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel
                  sx={{
                    fontSize: "0.875rem",
                    fontWeight: 500,
                    "&.Mui-focused": { color: "#6366f1" },
                  }}
                >
                  Select Users
                </InputLabel>
                <Select
                  multiple
                  value={assignmentData.user_ids}
                  onChange={(e) =>
                    setAssignmentData({ ...assignmentData, user_ids: e.target.value })
                  }
                  label="Select Users"
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((userId) => {
                        const user = users.find((u) => u.id === userId);
                        return (
                          <Chip
                            key={userId}
                            label={user?.name || "Unknown"}
                            sx={{
                              height: 24,
                              fontSize: "0.75rem",
                              bgcolor: "rgba(99, 102, 241, 0.1)",
                              color: "#6366f1",
                              border: "1px solid rgba(99, 102, 241, 0.3)",
                            }}
                          />
                        );
                      })}
                    </Box>
                  )}
                  sx={{
                    borderRadius: "12px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(99, 102, 241, 0.15)",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(99, 102, 241, 0.45)",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#6366f1",
                      borderWidth: "1.5px",
                    },
                  }}
                >
                  {users.map((user) => (
                    <MenuItem key={user.id} value={user.id}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 2,
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setAssignModalOpen(false);
                  setAssignmentData({
                    assignment_type: "class",
                    student_class: "",
                    user_ids: [],
                    access_type: "both",
                  });
                }}
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  padding: "8px 20px",
                  borderColor: "rgba(99, 102, 241, 0.3)",
                  "&:hover": {
                    borderColor: "#6366f1",
                    backgroundColor: "rgba(99, 102, 241, 0.04)",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleAssignQuiz}
                sx={{
                  background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                  color: "white",
                  borderRadius: "10px",
                  textTransform: "none",
                  padding: "8px 20px",
                  "&:hover": {
                    background: "linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%)",
                  },
                }}
              >
                Assign
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>

      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>


      <Dialog
  open={deleteAllQuizDialogOpen}
  onClose={() => setDeleteAllQuizDialogOpen(false)}
  PaperProps={{
    sx: {
      borderRadius: "16px",
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
      p: 2,
      width: "400px",
    },
  }}
>
  <DialogTitle
    sx={{
      fontWeight: "800",
      fontSize: "1.5rem",
      background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
      textAlign: "center",
      paddingBottom: "10px",
      borderBottom: "1px solid #f3f4f6",
    }}
  >
    Delete Quiz
  </DialogTitle>

  <DialogContent sx={{ textAlign: "center", py: 2 }}>
    <Typography variant="body1" sx={{ fontWeight: 500 }}>
      Are you sure you want to delete this quiz?
    </Typography>
  </DialogContent>

  <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 2 }}>
    <Button
      onClick={() => setDeleteAllQuizDialogOpen(false)}
      variant="outlined"
      sx={{
        borderRadius: "10px",
        textTransform: "none",
        padding: "8px 20px",
        borderColor: "rgba(99, 102, 241, 0.3)",
        "&:hover": {
          borderColor: "#6366f1",
          backgroundColor: "rgba(99, 102, 241, 0.04)",
        },
      }}
    >
      Cancel
    </Button>
    <Button
      onClick={handleDeleteQuiz}
      variant="contained"
      sx={{
        background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
        color: "white",
        borderRadius: "10px",
        textTransform: "none",
        padding: "8px 20px",
        "&:hover": {
          background: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
        },
      }}
    >
      Delete
    </Button>
  </DialogActions>
</Dialog>
    </Box>
  );
};

export default AllQuiz;